export enum MenuInventory {
  NFTStickers = 'NFT Stickers',
  FighterAvatars = 'Fighter avatars',
  NFTFusion = 'NFT Fusion',
  Items = 'Items',
  CertificateNFTs = 'Certificate NFTs',
}
